import { createEntity, readEntity } from "./delicDataClient";

export async function startDocumentConversion(input) {
  return createEntity("DocumentConversion", { input });
}

export async function getDocumentConversionJob({ jobId, personId, accountId }) {
  return readEntity("DocumentConversionJob", {
    jobId,
    personId,
    accountId,
  });
}
